import paste from './paste'

const install = function (Vue) {
  Vue.directive('paste', paste)
}

if (window.Vue) {
  window['paste'] = paste
  window.Vue.use(install)
}

paste.install = install
export default paste
